export default __webpack_public_path__ + "static/media/hm-fp-img.12abe435.webp";